import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { PerformanceEmployeesForSelectDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'

import { Variables } from './targetEnums'

interface Props {
  variables: Variables
  onSelectEmployees: (employeeIds: number[]) => void
}

export const ManualEmployeeFilter = ({ variables, onSelectEmployees }: Props) => {
  const [employeeIds, setEmployeeIds] = useState<number[]>([])
  const [initialEmployeeIds, setInitialEmployeeIds] = useState<number[]>([])
  const [fetched, setFetched] = useState(false)

  const { loading } = useQuery(PerformanceEmployeesForSelectDocument, {
    variables:
      variables.targetStrategy === 'by_employees'
        ? { ids: variables.arguments }
        : { accessIds: variables.arguments },
    skip:
      fetched ||
      !variables.arguments?.length ||
      (variables.targetStrategy !== 'by_employees' &&
        variables.targetStrategy !== 'manual_selection'),
    onCompleted: (data) => {
      const ids = data.employees.employeeNames.map((employee) => employee.id)
      setEmployeeIds(ids)
      setInitialEmployeeIds(ids)
      setFetched(true)
    },
  })

  const hasChanges = () => {
    if (employeeIds.length !== initialEmployeeIds.length) return true
    const sortedCurrent = [...employeeIds].sort((a, b) => a - b)
    const sortedInitial = [...initialEmployeeIds].sort((a, b) => a - b)
    return !sortedCurrent.every((id, index) => id === sortedInitial[index])
  }

  if (loading) {
    return <Loading />
  }

  return (
    <Box gap="s12" width="full" data-testid="target-group-manual-employee-filter">
      <EmployeeSelectorV2
        label={i18n.t('common.employees')}
        messages={{
          placeholder: i18n.t('employees.select_employee.other'),
        }}
        value={employeeIds}
        onChange={(state) => {
          if (state.type === 'manual') {
            setEmployeeIds(state.ids)
          }
        }}
        multiple
        options={{
          disableSelectAll: true,
        }}
      />
      <Box gap="s12" flexDirection="row" justifyContent="flexEnd" width="full">
        <F0Button
          label={i18n.t('common.save')}
          onClick={() => {
            onSelectEmployees(employeeIds)
            setInitialEmployeeIds(employeeIds)
          }}
          disabled={!hasChanges()}
        />
      </Box>
    </Box>
  )
}
